<template>
  <div class="mrDeskStatistics div-layout">
    <module-title title="课桌统计" />
    <!-- note:  去除了tabs操作 v1.8.1+ -->
    <!-- <el-tabs v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane label="课桌使用" name="desk">
        <div style="float: right; margin-bottom: 10px">
          <label for>起止日期：</label>
          <el-date-picker
            v-model="dateTime"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="起始时间"
            end-placeholder="截至时间"
            @change="handleChangeDate"
            :picker-options="datePickerOptions"
          />
        </div>
        <el-table
          v-loading="loading"
          :data="deskUseData"
          highlight-current-row
          fit
          border
          element-loading-text="Loading"
          class="list-table"
        >
          <el-table-column
            label="课桌数量（台）"
            align="center"
            prop="deskCount"
          />
          <el-table-column label="总天数" prop="totalDays" align="center" />
          <el-table-column
            label="总登录（次）"
            prop="totalLoginTimes"
            align="center"
          />
          <el-table-column
            label="总时长（时）"
            align="center"
            prop="totalTime"
          />
          <el-table-column
            label="平均每台天数"
            prop="totalDaysAve"
            align="center"
          />
          <el-table-column
            label="平均每台登录（次）"
            prop="totalLoginTimesAve"
            align="center"
          />
          <el-table-column
            label="平均每台时长（时）"
            prop="totalTimeAve"
            align="center"
          />
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="小孩学习" name="child">
        <div style="float: right; margin-bottom: 10px">
          <label for>起止日期：</label>
          <el-date-picker
            v-model="dateTime"
            :picker-options="datePickerOptions"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="起始时间"
            end-placeholder="截至时间"
            @change="handleChangeDate"
          />
        </div>

        <el-table
          v-loading="loading"
          :data="studentLearnData"
          highlight-current-row
          fit
          border
          element-loading-text="Loading"
          class="list-table"
        >
          <el-table-column
            label="小孩（数量）"
            align="center"
            prop="studentCount"
          />
          <el-table-column
            label="学习模块（数量）"
            prop="contentCount"
            align="center"
          />
          <el-table-column
            label="学习时长（小时）"
            prop="duration"
            align="center"
          />
          <el-table-column
            label="平均每个小孩学习模块（数量）"
            align="center"
            prop="contentCountAve"
            width="220"
          />
          <el-table-column
            label="平均每个小孩学习时长（时）"
            prop="durationAve"
            align="center"
            width="210"
          />
          <el-table-column
            label="平均每个小孩单个模块学习时长（时）"
            prop="contentCountDurationAve"
            align="center"
            width="280"
          />
        </el-table>
      </el-tab-pane>
    </el-tabs> -->

    <main>
      <el-form
        ref="afterSaleStatisticsForm"
        :model="searchForm"
        :inline="true"
        :rules="handleRules"
        hide-required-asterisk
        label-position="right"
        label-width="100px"
        class="flex align-c flex-b"
      >
        <section>
          <el-form-item label="设备SN号：" prop="deviceNo">
            <el-input
              v-model="searchForm.deviceNo"
              name="deviceNo"
              maxlength="20"
              placeholder="输入设备SN号"
              class="handle-form-input"
              clearable
            />
          </el-form-item>
          <el-form-item style="margin-left: 20px">
            <el-button
              type="primary"
              size="medium"
              icon="el-icon-search"
              @click="handleSearchFilter"
            >
              查询
            </el-button>
          </el-form-item>
        </section>
        <el-form-item label="起止日期：" prop="dateTime">
          <el-date-picker
            v-model="searchForm.dateTime"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="起始时间"
            end-placeholder="截至时间"
            :picker-options="datePickerOptions"
            @change="handleChangeDate"
          />
        </el-form-item>
      </el-form>

      <el-table
        v-loading="loading"
        :data="deskUseData"
        highlight-current-row
        fit
        border
        element-loading-text="Loading"
        class="list-table"
      >
        <el-table-column
          label="课桌数量（台）"
          align="center"
          prop="deskCount"
        />
        <el-table-column label="总天数" prop="totalDays" align="center" />
        <el-table-column
          label="总登录（次）"
          prop="totalLoginTimes"
          align="center"
        />
        <el-table-column label="总时长（时）" align="center" prop="totalTime" />
        <el-table-column
          label="平均每台天数"
          prop="totalDaysAve"
          align="center"
        />
        <el-table-column
          label="平均每台登录（次）"
          prop="totalLoginTimesAve"
          align="center"
        />
        <el-table-column
          label="平均每台时长（时）"
          prop="totalTimeAve"
          align="center"
        />
      </el-table>
    </main>

    <div class="description docDescription">
      <h4>统计说明</h4>
      <!--  <p class="redText">课桌设备、使用者(小孩)两个维度统计相关数据，如下：</p> -->
      <p><label for>总天数：</label>课桌使用天数累计</p>
      <p><label for>总登录：</label>课桌开机次数累计</p>
      <p><label for>总时长：</label>课桌开机至关机使用时间累计</p>
      <!-- <p>
        <label for>学习模块：</label
        >栏目或频道，比如同步学习、名师课堂、模拟考试属于三个栏目，每个用户使用过的独立栏目统计
      </p>
      <p>
        <label for>学习时长：</label
        >指小孩使用学习栏目的使用时间，排除了未使用学习栏目的时间（比如：桌面停留或离开课桌吃饭等）
      </p> -->
      <p><label for>查询时段：</label>选择起止时期，查询该时段内产生的数据</p>
      <!--  <p>
        <label for>区域统计：</label>按区域统计数据，当前尚无数据来源，以后迭代
      </p> -->
      <p>
        <label for>课桌数量：</label>不代表销售数据，用户购买课桌且已使用才计数
      </p>
      <p class="red">
        登录及时长的统计因设备会有特殊情况发生会干扰到数据的精准性，统计结果会有0.5%的容错。
      </p>
    </div>
  </div>
</template>

<script>

import { getNowFormatDate, getupFormatDate } from '@/utils/index';
import { getDeskList } from '@/api/productOperation/mrDesk/statistics';
export default {
  name: 'MrDeskStatistics',

  data() {
    return {
      startDate: getupFormatDate(null, null, 3),
      endDate: getNowFormatDate(),
      activeName: 'desk',
      datePickerOptions: {
        disabledDate(time) {
          return (
            time.getTime() > Date.now() - 8.64e7 ||
            time.getTime() < Date.now() - 3 * 31 * 24 * 60 * 60 * 1000 - 8.64e7
          ); // 如果有后面的-8.64e7就是不可以选择今天
        }
      },
      deskUseData: [],
      loading: false,
      studentLearnData: [],
      // 搜索表单
      searchForm: {
        dateTime: [getupFormatDate(null, null, 3), getNowFormatDate()],
        deviceNo: ''
      },
      // form检测
      handleRules: {
        dateTime: [
          {
            required: true,
            message: '请选择起止日期',
            trigger: 'change'
          }
        ]
      }
    };
  },
  mounted() {
    this.searchDeskList();
  },
  methods: {
    handleChangeDate(val) {
      if (val && val.length > 0) {
        this.startDate = val[0];
        this.endDate = val[1];
        this.searchDeskList();
      } else {
        this.startDate = '';
        this.endDate = '';
      }
    },
    handleTabClick(val) {
      this.activeName = val.name;
      this.startDate = getupFormatDate(null, null, 3);
      this.endDate = getNowFormatDate();
      this.searchDeskList();
    },
    // 条件查询
    handleSearchFilter() {
      this.searchDeskList();
    },
    searchDeskList() {
      this.loading = true;
      const sumbitObj = {
        startDate: this.startDate,
        endDate: this.endDate,
        deviceNo: this.searchForm.deviceNo
      };
      getDeskList(sumbitObj)
        .then((result) => {
          // this.studentLearnData = [result.data.deskStudyStatisticsVO];
          this.deskUseData = [result.data.deskUseStatisticsVO];
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          // this.studentLearnData = [];
          this.deskUseData = [];
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.mrDeskStatistics {
  .flex{
    padding-right: 10px;
  }
  .mrDeskStatistics-main {
    padding: 0 20px;
    .mr-desk-use {
      line-height: 36px;
      h1 {
        float: left;
      }
      .el-button {
        float: right;
      }
    }
    .description {
      margin-top: 50px;
      p:first-child {
        margin-bottom: 20px;
      }
      p:nth-child(6) {
        margin-bottom: 20px;
      }
    }
  }
  .date-input {
    width: 150px;
  }
  .el-form--inline .el-form-item {
    margin-right: 0;
  }
}
</style>
